import { ArrowRight, ArrowDown } from "lucide-react";

/**
 * Horizontal-on-desktop / vertical-on-mobile flow diagram with arrows between steps.
 * Steps are rendered as an accessible ordered list; arrows are decorative.
 *
 * @param {Object} props
 * @param {string[]} props.steps
 * @param {"compact" | "full"} [props.variant="full"]
 * @param {string} [props.className]
 */
const FlowDiagram = ({ steps, variant = "full", className = "" }) => {
  const isCompact = variant === "compact";

  return (
    <ol
      data-testid="flow-diagram"
      className={`flex flex-col md:flex-row md:flex-wrap md:items-center gap-2 md:gap-1 ${className}`}
    >
      {steps.map((step, i) => (
        <li key={step} className="flex items-center gap-2 md:gap-1">
          <span
            className={`${
              isCompact
                ? "text-[12px] md:text-[13px] font-medium text-ecospora-charcoal/85 px-3 py-1.5 rounded-full bg-ecospora-cream border border-ecospora-green-deep/15"
                : "text-sm md:text-base font-semibold text-ecospora-green-deep px-4 py-2 rounded-full bg-ecospora-cream border border-ecospora-green-deep/20"
            }`}
          >
            {step}
          </span>
          {i < steps.length - 1 && (
            <>
              <ArrowRight
                aria-hidden="true"
                size={isCompact ? 14 : 16}
                strokeWidth={1.5}
                className="hidden md:inline text-ecospora-green-mid shrink-0"
              />
              <ArrowDown
                aria-hidden="true"
                size={isCompact ? 14 : 16}
                strokeWidth={1.5}
                className="md:hidden text-ecospora-green-mid shrink-0 ml-1"
              />
            </>
          )}
        </li>
      ))}
    </ol>
  );
};

export default FlowDiagram;
